import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, Icon } from "semantic-ui-react";
import useTheme from "../../hooks/useTheme";
import { AppColumn } from "../UI/Layouts";
import { SizedBox } from "../UI/Sizes";
import AppText from "../UI/Texts/AppTexts";
import { AppPrimaryButton } from "../UI/CustomButtons";

export const MODAL_ONBOARDING_COMPLETION = "OnboardingCompletionModal";

const OnboardingCompletionModal = ({ closeModal, lookingForJob = true, onComplete }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const handleComplete = () => {
    closeModal();
    if (onComplete) {
      onComplete();
    }
  };

  return (
    <Modal
      open={true}
      onClose={closeModal}
      size="tiny"
      style={{
        borderRadius: theme.radius.default,
      }}
    >
      <Modal.Content
        style={{
          padding: theme.spacing.contentPadding,
          textAlign: "center",
        }}
      >
        <AppColumn crossAxisAlignment="center">
          {/* Success Icon */}
          <div
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              backgroundColor: theme.primaryColor,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: theme.spacing.elementPadding,
            }}
          >
            <Icon
              name="check"
              size="big"
              style={{
                color: theme.colors.white,
                margin: 0,
              }}
            />
          </div>

          <SizedBox height={theme.spacing.elementPaddingSmall} />

          {/* Heading */}
          <AppText.HeadingSmall fontWeight={600}>
            {t("profile.onboarding_completion.title")}
          </AppText.HeadingSmall>

          <SizedBox height={theme.spacing.elementPadding} />

          {/* Description */}
          <AppText.BodyText
            color={theme.colors.grey}
            style={{
              textAlign: "center",
              lineHeight: "1.6",
            }}
          >
            {lookingForJob
              ? t("profile.onboarding_completion.description_looking")
              : t("profile.onboarding_completion.description_not_looking")}
          </AppText.BodyText>

          <SizedBox height={theme.spacing.contentPadding} />

          {/* OK Button */}
          <AppPrimaryButton
            size="large"
            onClick={handleComplete}
            style={{
              minWidth: "200px",
            }}
          >
            {t("ok")}
          </AppPrimaryButton>
        </AppColumn>
      </Modal.Content>
    </Modal>
  );
};

export default OnboardingCompletionModal;
